module.exports = __webpack_public_path__ + "media/top_bg.0af9dded.png";